<template>
    <div id="alerts-widget-component">
        <widget-wrapper-component :title="$t('alerts_triggered_widget_component.alerts_triggered')" id-widget="alerts-triggered-widget">
            <template v-slot:options>
                <menu-actions-component
                    :actions="[
                        {
                            title: $t('manage_alert_page.manage_alert'),
                            icon: 'mdi-bell-cog',
                            emit: 'openManageAlertPage',
                            has_access: userHasAccess('BASE', role_vision),
                        },
                    ]"
                    v-on:openManageAlertPage="
                        $router.push({ path: `/equipment/manage_alert/${asset.id_asset}?asset_module=${asset_module.id_module}` })
                    "
                />
            </template>

            <template v-slot:default>
                <v-tabs v-model="current_tab" class="mb-4">
                    <v-tab>{{ $t('alerts_triggered_widget_component.alerts_triggered') }}</v-tab>
                    <v-tab>{{ $t('alerts_configured_component.alerts_parameter') }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="current_tab">
                    <v-tab-item>
                        <alerts-list-component
                            :alerts="alerts_triggered"
                            :loading="fetching_alerts"
                            :triggered="true"
                            v-on:refresh:alert="fetchAlertTriggeredByAsset"
                        />
                    </v-tab-item>

                    <v-tab-item>
                        <alerts-list-component
                            :alerts="alerts_all"
                            :loading="fetching_alerts"
                            v-on:refresh:alert="fetchAlertTriggeredByAsset"
                        />
                    </v-tab-item>
                </v-tabs-items>
            </template>
        </widget-wrapper-component>
    </div>
</template>

<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import MenuActionsComponent from '@/components/global/containment/MenuActionsComponent.vue'
import AlertsListComponent from '@/components/alert/containment/AlertsListComponent.vue'

export default {
    name: 'AlertsWidgetComponent',
    components: { MenuActionsComponent, WidgetWrapperComponent, AlertsListComponent },
    props: {
        asset: {
            type: Object,
            required: true,
        },
        asset_module: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            current_tab: 0,
            fetching_alerts: true,
        }
    },
    computed: {
        alerts_all() {
            return this.$store.getters['alerts/alertsByAsset'](this.asset)
        },
        alerts_triggered() {
            return this.alerts_all.filter((alert) => alert.triggered === true)
        },
    },
    methods: {
        fetchAlertTriggeredByAsset() {
            this.fetching_alerts = true
            this.$store
                .dispatch('alerts/fetchAlertsByAsset', this.asset)
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.fetching_alerts = false
                })
        },
    },
    created() {
        this.fetchAlertTriggeredByAsset()
    },
}
</script>
